import { render, staticRenderFns } from "./PhotoSelection.vue?vue&type=template&id=5e2447a0&scoped=true&"
import script from "./PhotoSelection.vue?vue&type=script&lang=ts&"
export * from "./PhotoSelection.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoSelection.vue?vue&type=style&index=0&id=5e2447a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2447a0",
  null
  
)

component.options.__file = "PhotoSelection.vue"
export default component.exports